import {
  panoramaClientFactory,
  PanoramaPlatform,
} from "@wix/panorama-client-web";
import { ARTIFACT_ID } from "../consts";
import { panoramaGlobalConfig } from "../config";
import { isServerSideRendering } from "./utils";

export const createPanoramaClient = (userDetails: any) => {
  const isSSR = isServerSideRendering();
  const options = {
    baseParams: {
      platform: PanoramaPlatform.Standalone,
      fullArtifactId: `com.wixpress.picasso.${ARTIFACT_ID}`,
      componentId: "picasso-landing-page",
      uuid: userDetails?.id,
    },
    pluginParams: {
      ...(!isSSR && {
        // @ts-expect-error - Sentry is not typed
        sentry: window.Sentry,
        sentryDsn:
          "https://7049671f0161d0046b17151510c28b3a@o37417.ingest.us.sentry.io/4509790356045824",
        sentryMain: true,
      }),
    },
  };
  const panoramaFactory =
    panoramaClientFactory(options).withGlobalConfig(panoramaGlobalConfig);
  return panoramaFactory.client(options);
};
